import { masterClient } from '@aps-management/primapp-common';
import { v4 as uuidv4 } from 'uuid';

import store from '_config/store';

function getContext() {
  const context = {};
  const { golf, token } = store.getState().app;
  if (golf) context.golfId = golf.id;
  if (token) context.accessToken = token;
  // En-tête de corrélation client<->serveur : le lien Apollo de primapp-common
  // recopie `context.headers` dans les en-têtes HTTP (`{ ...headers }`). Sans lui,
  // master générait un `reqId` par appel sans aucun lien avec le client. Un id par
  // requête HTTP ici ; suivre un paiement entier sous un seul id demanderait de
  // threader un id de corrélation à travers la séquence de paiement.
  context.headers = { 'x-request-id': uuidv4() };
  return context;
}

/* */
const client = {
  /* */
  query: ({ query, variables, fetchPolicy, errorPolicy }) =>
    masterClient.query({
      query,
      variables,
      fetchPolicy,
      errorPolicy,
      context: getContext(),
    }),
  /* */
  mutate: ({ mutation, variables, errorPolicy }) =>
    masterClient.mutate({
      mutation,
      variables,
      errorPolicy,
      context: getContext(),
    }),
};

export default client;
